import mapboxgl from "mapbox-gl";
import { allSelectableLayers } from "../../constants/constants";
import { getFeaturesCardsGroupIds,  
        getRelatedFeatureIds, 
        removeRepeatedFeatures,
        getHoveredFeatures } from "../cardsGroupsFeatures";
import { store } from "../..";

export function highlightManager(map, props, handleOpenPopup) {
    let start;
    let current;
    let box;
    const canvas = map.getCanvasContainer();
    canvas.addEventListener('mousedown', mouseDown, true);

    document.addEventListener('keydown', keyDown);

    let ctrlFeatures = []
    let keyPressed = false
    function keyDown(e) {
        const state = store.getState()
        if (state.popUpMenu.show) {
            if (!e.metaKey) return
        } else {
            if (!e.ctrlKey && !e.metaKey) return
        }
        if (!keyPressed) {
            document.addEventListener('keyup', keyUp);
            keyPressed = true
            map.off('click', handleOpenPopup)
            map.on('click', getCtrlFeatures)
        }
    }

    function keyUp() {
        map.off('click', getCtrlFeatures);
        map.on('click', handleOpenPopup);
        let cardsGroupIds = getFeaturesCardsGroupIds(map, ctrlFeatures);
        if (cardsGroupIds.length > 0) {
            props.popUpMenuChange({ show: true });
            props.selectedCardsGroupsChange(cardsGroupIds);
        } else {
            props.popUpMenuChange({ show: false, expanded: false, cyclesButton: false, changeMenuButton: false });
        }
        ctrlFeatures = [];
        keyPressed = false;
        document.removeEventListener('keyup', keyUp);
        removeHighlight(map, ctrlFeatures);
    }

    function getCtrlFeatures(event) {
        let bbox = [
            [event.point.x - 5, event.point.y - 5],
            [event.point.x + 5, event.point.y + 5]
        ];
        let map = event.target;
        const selectedFeatures = map.queryRenderedFeatures(bbox, {
            layers: allSelectableLayers
        });
        const hoveredFeatures = getHoveredFeatures(selectedFeatures);
        if (hoveredFeatures.length) {
            ctrlFeatures = ctrlFeatures.concat(hoveredFeatures);
            addHighlight(map, hoveredFeatures);
        }
    }
    
    function mousePos(e) {
        const rect = canvas.getBoundingClientRect();
        return new mapboxgl.Point(
            e.clientX - rect.left - canvas.clientLeft,
            e.clientY - rect.top - canvas.clientTop
        );
    }

    function mouseDown(e) {
        if (!e.shiftKey || e.ctrlKey || e.metaKey) return;
        map.dragPan.disable();
        map.off('click', handleOpenPopup)
        removeHighlight(map)
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        start = mousePos(e);
    }
    
    function onMouseMove(e) {
        current = mousePos(e);
        
        if (!box) {
            box = document.createElement('div');
            box.classList.add('boxdraw');
            canvas.appendChild(box);
        }
    
        const minX = Math.min(start.x, current.x),
        maxX = Math.max(start.x, current.x),
        minY = Math.min(start.y, current.y),
        maxY = Math.max(start.y, current.y);
        
        const pos = `translate(${minX}px, ${minY}px)`;
        box.style.transform = pos;
        box.style.width = maxX - minX + 'px';
        box.style.height = maxY - minY + 'px';
    }
    
    function onMouseUp(e) {
        let end = mousePos(e)
        if (start.y < end.y) {
            finish([start, end])
        } else {
            finish([end, start])
        }
    }

    function finish(bbox) {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);

        if (box) {
            box.parentNode.removeChild(box);
            box = null;
        }
         
        if (bbox) {
            const features = map.queryRenderedFeatures(bbox, {
                layers: allSelectableLayers
            });
            let filteredFeatures = removeRepeatedFeatures(features);
            addHighlight(map, filteredFeatures);
            let cardsGroupIds = getFeaturesCardsGroupIds(map, filteredFeatures);
            if (cardsGroupIds.length > 0) {
                props.popUpMenuChange({ show: true });
                props.selectedCardsGroupsChange(cardsGroupIds);
            } else {
                props.popUpMenuChange({ show: false, expanded: false, cyclesButton: false, changeMenuButton: false });
            }
        }
        map.on('click', handleOpenPopup);

        map.dragPan.enable();
    }
}

export function addHighlight(map, features) {
    features.forEach(feature => {
        map.setFeatureState(
            { source: 'cards', id: feature.id },
            { highlight: true }
        )
        let relatedFeatureIds = getRelatedFeatureIds(map, feature);
        for (const featureId of relatedFeatureIds) {
            map.setFeatureState(
                { source: 'cards', id: featureId },
                { highlight: true }
            );
        }
    })
}

export function removeHighlight(map, features=null) {
    if (!features) {
        features = map.querySourceFeatures('cards')
    }
    features.forEach(feature => {
        map.setFeatureState(
            { source: 'cards', id: feature.id },
            { highlight: false }
        )
    })
}